import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { colors } from '@spaceshipapp/cambridge';

const GlobalStyles = createGlobalStyle`
  ${normalize};
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  html {
    font-size: 100%;
    scroll-behavior: smooth;
    overflow: hidden;
  }
  body {
    font-size: 1.6rem;
    height: 100%;
    background: ${colors.border};
    color: ${colors.text};
    cursor: default;
  }

  a {
    text-decoration: none;
  }
  li{
    list-style: none;
  }
`;

export default GlobalStyles;
